import { Slider } from '../controls/Slider';
import { useActive } from './useActive';

export function ColorPanel() {
  const { settings, update } = useActive();
  return (
    <div>
      <Slider
        label="vibrance"
        testId="slider-vibrance"
        value={settings.color.vibrance}
        min={-100}
        max={100}
        step={1}
        onChange={(v, f) => update((s) => void (s.color.vibrance = v), f)}
      />
      <Slider
        label="saturation"
        testId="slider-saturation"
        value={settings.color.saturation}
        min={-100}
        max={100}
        step={1}
        onChange={(v, f) => update((s) => void (s.color.saturation = v), f)}
      />
    </div>
  );
}
